import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMegaphone = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.114 10.813 19.25 5.786V18.1L4.113 13.06a.56.56 0 0 1-.265-.185.46.46 0 0 1-.098-.256v-1.342a.46.46 0 0 1 .094-.273.56.56 0 0 1 .27-.191m15.432-6.549a1.4 1.4 0 0 0-.64.055L3.64 9.389c-.397.133-.746.381-.997.718a1.96 1.96 0 0 0-.392 1.165v1.39c.015.411.16.805.41 1.13.25.323.592.562.98.691l1.88.626v1.475a4.1 4.1 0 0 0 1.202 2.872 4.42 4.42 0 0 0 2.892 1.287 4.46 4.46 0 0 0 3.024-.955 4.2 4.2 0 0 0 1.338-1.863l4.924 1.64.007.001a1.43 1.43 0 0 0 1.24-.176c.18-.123.332-.287.438-.482s.163-.413.165-.636V5.614a1.35 1.35 0 0 0-.165-.637 1.4 1.4 0 0 0-.438-.482 1.4 1.4 0 0 0-.6-.231m-6.993 13.187-5.534-1.842v.97c.003.671.274 1.323.768 1.82a2.92 2.92 0 0 0 1.91.846c.734.041 1.451-.187 2.006-.63.394-.314.684-.717.85-1.164"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgMegaphone;
